var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city"},[_c('ul',_vm._l((_vm.cityArr),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.backFn(index)}}},[_vm._v("\n            "+_vm._s(item)+"\n        ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b648834","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/city/cityList.vue
// module id = null
// module chunks = 